module.exports = __webpack_public_path__ + "media/waiting-room-6.62234793.mp4";